<template>
  <div
    class="graduate-card"
    @click="
      $router.push({
        name: 'Detail',
        params: { id: graduate.id }
      })
    "
  >
    <div class="graduate-picture">
      <div class="graduate-image">
        <v-img :src="src"></v-img>

        <div class="graduate-image-texture">
          <v-img
            :src="
              require(`@/assets/img/texture_${Math.floor(
                Math.random() * 4
              )}.jpg`)
            "
          ></v-img>
        </div>
      </div>
      <div class="graduate-picture-diploma">{{ graduate.diploma }}</div>
      <div class="graduate-picture-year"><span>2</span>0<span>2</span>0</div>
      <div class="graduate-picture-website">
        remisetitres.fr.ch<br />uebergabeltitel.fr.ch
      </div>
    </div>
    <div class="graduate-info">
      <div
        class="graduate-info-name"
        v-html="graduate.firstname + ' ' + graduate.lastname"
      ></div>
      <div class="graduate-info-profession" v-html="graduate.profession"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    graduate: Object
  },
  computed: {
    src() {
      return this.graduate.pictures_list[0].replace(
        'public://pictures',
        'https://api.frogfish.dev/sites/default/files/styles/portrait/public/pictures'
      )
    }
  }
}
</script>

<style lang="scss">
.graduate-card {
  margin-bottom: 14px;
  cursor: pointer;
  transition: transform 0.2s;

  &:hover {
    transform: scale(1.05);
  }
}

.graduate-picture {
  position: relative;
  padding: 30px 10px 70px 42px;
  border: solid 2px #000;
  box-shadow: 4px 4px 10px 0px rgba(0, 0, 0, 0.55);
  background: #fff;
}

.graduate-image {
  position: relative;
}

.graduate-image-texture {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  opacity: 0.4;

  .v-image {
    height: 100%;
    object-fit: cover;
  }
}

.graduate-picture-diploma {
  position: absolute;
  bottom: 0;
  left: 0;
  padding-left: 10px;

  font-size: 65px;
  line-height: 1;

  transform: translateY(100%) rotate(-90deg);
  transform-origin: top left;
}

.graduate-picture-year {
  position: absolute;
  top: 0;
  left: 0;
  padding-right: 10px;

  font-size: 65px;
  line-height: 1;
  -webkit-text-stroke: 1px black;
  -webkit-text-fill-color: transparent;

  transform: translateX(-100%) rotate(-90deg);
  transform-origin: top right;

  span {
    font-family: 'Langulaire';
  }
}

.graduate-picture-website {
  position: absolute;
  right: 10px;
  bottom: 6px;

  font-size: 11px;
  line-height: 14px;
  text-align: right;
}

.graduate-info {
  padding: 25px 0;
  text-align: center;
}

.graduate-info-name {
  margin-bottom: 0.2em;

  font-size: 16px;
  line-height: 1.3;
  text-transform: uppercase;
}

.graduate-info-profession {
  font-size: 16px;
  line-height: 1.3;
}
</style>
